import React, { useEffect } from 'react';
import {
  ButtonWithAction,
  FormInput,
  Cluster,
  constants,
  Box,
} from '@thecb/components';
import { SearchIcon } from '../../components/search-icons';
import styled from 'styled-components';

const OrdersIndexSearchInputWrapper = styled.div`
  .searchOrderNumberSearchIcon {
    width: 2rem;
  }

  .searchOrderNumberInput {
    border: 0;
    width: 860px;
    margin-top: 0.25rem;
  }
`;

const OrdersIndexSearchInput = ({
  fields,
  actions,
  clear,
  shouldClear,
  fetchData,
  handleSubmit,
}) => {
  useEffect(() => {
    if (shouldClear) {
      actions.fields.orderNumber.set('');
      fetchData({ pageIndex: 1 });
    }
  }, [shouldClear]);

  const searchErrors = {};

  return (
    <OrdersIndexSearchInputWrapper>
      <Cluster
        childGap="0.25rem"
        justify="space-around"
        align="center"
        minHeight="100%"
        minWidth="100%"
      >
        <Cluster
          extraStyles={`overflow: visible;`}
          align="center"
          justify="space-between"
        >
          <Box padding="0px 12px 0px 0px">
            <SearchIcon color={constants.colors.LUCKY_POINT} />
          </Box>
          <FormInput
            placeholder="Search by order number"
            themeValues={{ lineHeight: 0 }}
            data-testid="order-number-input"
            className="searchOrderNumberInput"
            errorMessages={searchErrors}
            field={fields.orderNumber}
            errors={fields.orderNumber.errors}
            fieldActions={actions.fields.orderNumber}
            labelTextVariant="p"
            errorTextVariant="p"
          />
        </Cluster>
        <ButtonWithAction
          variant="smallGhost"
          type="reset"
          text={'Clear Search'}
          data-testid="orders-clear-search"
          action={() => {
            clear();
          }}
        />
        <ButtonWithAction
          type="submit"
          minWidth="0"
          width="3rem"
          padding=".5rem"
          minHeight="0"
          extraStyles={`line-height: 1;`}
          data-testid="orders-submit-filters"
          variant="primary"
          contentOverride={true}
          action={handleSubmit}
        >
          <SearchIcon
            color={constants.colors.WHITE}
            className="searchOrderNumberSearchIcon"
          />
        </ButtonWithAction>
      </Cluster>
    </OrdersIndexSearchInputWrapper>
  );
};

export { OrdersIndexSearchInput };
